import React from "react";
import MapaInfo from "../../Listado/components/MapaInfo";

export default function MapaInfoDinamico({
  selectedElement,
  cab,
}) {
  return <MapaInfo selectedElement={selectedElement} mapaInfo={cab} />;
}
